export class TokenRequestRoot {
    loginId!: string;
    password!: string;
}
